<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Featured Content</h1>
          </div>
        </div>

        <home-section
          v-for="(sectionName, index) in sectionsList"
          :id="index + 1"
          :key="sectionName"
          :name="sectionName"
          :content-props="contentList[index + 1]"
          :loading="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import HomeSection from './HomeSection';

export default {
  name: 'FaturedArticles',

  components: {
    'home-section': HomeSection,
  },

  data() {
    return {
      contentList: [],
      isLoading: false,
    };
  },

  computed: {
    sectionsList() {
      return this.$store.state.homeSections;
    },
  },

  mounted() {
    this.getFeaturedArticles();
  },

  methods: {
    getFeaturedArticles() {
      this.isLoading = true;
      this.$apiHttp.get(`${this.$config.app_api.prefix}featured-content`)
        .then((response) => {
          this.contentList = _.cloneDeep(response.data);
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting list request' });
          console.log('Error in getting featured articles request ', error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?502157d6